<template>
  <div class="form-wrapper">
    <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="formData.title" label="Work Flow Name" :rules="RULES.REQUIRED_FIELD('Name')" required
            variant="outlined" density="compact" placeholder="e.g. Appointment Reminder Flow" hide-details="auto" />
        </v-col>

        <v-col cols="12">
          <v-select v-model="formData.workflow_type" :items="['PatientAppointment']" item-title="title" item-value="id"
            label="Type" required variant="outlined" density="compact" placeholder="Choose a type"
            hide-details="auto" />
        </v-col>

        <v-col cols="12">
          <v-textarea v-model="formData.description" label="Description" :rules="RULES.REQUIRED_FIELD('Description')"
            variant="outlined" density="compact" rows="2" hide-details />
        </v-col>
      </v-row>

      <div class="form-actions">
        <v-btn size="small" variant="text" @click="handleCancel">
          Cancel
        </v-btn>
        <v-btn size="small" color="primary" variant="flat" :disabled="!valid" @click="handleSubmit">
          Next: Design Work Flow
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { RULES } from "../../constants/validationRules.js"

export default {
  name: 'WorkFlowCreateForm',
  emits: ['submit', 'cancel'],
  data() {
    return {
      valid: false,
      formData: {
        title: '',
        description: '',
        workflow_type: 'PatientAppointment'
      },
      RULES
    }
  },

  methods: {

    async handleSubmit() {
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        const configData = {
          title: this.formData.title,
          description: this.formData.description,
          workflow_type: this.formData.workflow_type
        }
        this.$emit('submit', configData)
      }
    },

    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.form-wrapper {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 24px;
}

.form-wrapper :deep(.v-field-label) {
  font-size: 12px;
}

.form-wrapper :deep(.v-field input),
.form-wrapper :deep(.v-field textarea),
.form-wrapper :deep(.v-select__selection-text) {
  font-size: 13px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
</style>
